export default "__VITE_ASSET__EIazjvcW__"